<script>
// import axios from "axios";
// import simplebar from "simplebar-vue";
import { Translator } from 'vue-google-translate';
import { financialyearComputed, financialyearMethods } from '../state/helpers';

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      arrayOfCountries: [
        {
          code: 'en|en',
          title: 'English',
        },

        {
          code: 'en|fr',
          title: 'French',
        },

        {
          code: 'en|ar',
          title: 'Arabic',
        },

        {
          code: 'en|es',
          title: 'Spanish',
        },

        {
          code: 'en|de',
          title: 'German',
        },

        {
          code: 'en|sw',
          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',
          title: 'Kiswahili',
        },

        {

          code: 'en|lg',

          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',

          title: 'Luganda',

        },],
    };
  },
  components: {
    Translator,
  },
  computed: {
    ...financialyearComputed,
    selectedFinancialYear() {
      return this.financialyears.find((year) => year.id === this.currentFinancialYear) || JSON.parse(localStorage.getItem("financialyear"));
    }
  },
  methods: {
    ...financialyearMethods,

    customEvent() {
      this.$router.push(this.$route.query.redirectFrom || { name: "default", })
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    formatDate(date) {
      let d = new Date(date);
      let month = d.toLocaleString('default', { month: 'long' });
      let year = d.getFullYear();
      return [month, year].join(' ');
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    onSelectFinancialYear(year) {
      this.$store.dispatch("financialyears/fetchSetFinancialYearData", year);
    },
    resetToActiveFinancialYear() {
      const activeYear = JSON.parse(localStorage.getItem("financialyear"));
      if (activeYear) {
        this.$store.dispatch("financialyears/fetchSetFinancialYearData", activeYear);
      }
    },
  },

};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" style="background-color: black;">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <img src="@/assets/images/tandika-logo.png" height="40" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/tandika-logo.png" height="70" />
            </span>
          </router-link>
        </div>


        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h4 text-primary"> <b>{{ userData.business }} </b> </span> |
          <span class="h6"><i class="fas fa-map-marker-alt"></i> {{ userData.location }} </span> |
          <span class="h6"><i class="fas fa-phone-alt"></i> {{ userData.contact }} </span>
        </span>



      </div>

      <div class="d-flex">
        <!-- Switch Between Financial Years -->

        <div class="header-item">
          <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
            <template v-slot:button-content>
              <i class="mdi mdi-calendar-clock"></i>
              <span v-if="selectedFinancialYear" class="d-none d-xl-inline-block mt-n2 ms-1 fw-bold">
                FY {{ formatDate(selectedFinancialYear.start) }} - {{ formatDate(selectedFinancialYear.end) }}
              </span>
              <span v-else class="d-none d-xl-inline-block mt-n2 ms-1 fw-bold">
                Financial Year
              </span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </template>
            <div class="dropdown-item border-bottom mb-2">
              <div class="text-secondary fs-4">Financial Year</div>
            </div>
            <b-dropdown-item v-for="year in financialyears" :key="year.id" @click="onSelectFinancialYear(year)">
              {{ formatDate(year.start) }} - {{ formatDate(year.end) }} <span v-if="year.active == 1"
                class="badge bg-success ms-2">Active</span>
            </b-dropdown-item>

          </b-dropdown>

          <span v-if="selectedFinancialYear && selectedFinancialYear.active != 1"
            class="badge bg-warning mx-1 p-1">Viewing Past
            Financial Year
            Data</span>
          <button v-if="selectedFinancialYear && selectedFinancialYear.active != 1" @click="resetToActiveFinancialYear"
            class="ms-2 btn btn-sm btn-outline-primary"><i class="mdi mdi-refresh"></i> Reset</button>


        </div>



        <!-- Fullscreen Button -->
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen"><i
              class="bx bx-fullscreen"></i></button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <div class="dropdown-item border-bottom mb-2">
            <div class="text-secondary fs-4">{{ userData.member.name }}</div>
            <span class="d-block text-info fw-bold">Member No: {{ userData.member.member_id }}</span>
          </div>
          <router-link :to="{
            path: '/member-profile',
            query: { id: userData.member.member_id },
          }" class="dropdown-item fw-bold">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>Full Profile
          </router-link>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
